<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <div>
        <i class="pi pi-cloud-upload title-card-icon"></i>
      </div>
      <div>
        <p class="mb-0 text-3xl title">{{'menu.subscriptions' | transloco}}</p>
        <p>{{'menu.descriptions.userSubscriptions' | transloco}}</p>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows p-datatable-no-header">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-end">
            <div class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
          </div>
        </div>
        <p-table [(first)]="first" [(rows)]="rows" [paginator]="true"
                 [value]="subscriptions" [responsive]="true" [rowsPerPageOptions]="[10,25,50]"
                 [totalRecords]="totalSubscriptions" sortField="subscription.startDate" styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">{{'attribute.username' | transloco}}</th>
              <th scope="col">{{'attribute.serialNumber' | transloco}}</th>
              <th scope="col">{{'attribute.startDate' | transloco}}</th>
              <th scope="col">{{'attribute.endDate' | transloco}}</th>
              <th scope="col">{{'attribute.status' | transloco}}</th>
              <th scope="col">{{'attribute.organization' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template let-subscription pTemplate="body">
            <tr *ngIf="!loadingSubscriptions">
              <td>{{subscription.username}}</td>
              <td><a
                [routerLink]="['/machines', subscription.machineUuid, 'details']">{{subscription.serial}}</a>
              </td>
              <td>{{subscription.startDate | customDateSubscription}}</td>
              <td>{{subscription.endDate | customDateSubscription}}</td>
              <td
                *ngIf="subscription.active">{{'attribute.statusActive' | transloco}}</td>
              <td
                *ngIf="!subscription.active">{{'attribute.statusInactive' | transloco}}</td>
              <td>{{subscription.organizationName}} ({{subscription.organizationCode}})</td>
            </tr>
            <tr *ngIf="loadingSubscriptions">
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div *ngIf="totalSubscriptions == 0"
                 class="flex align-items-center justify-content-between">{{'pagination.empty' | transloco}}</div>
            <div *ngIf="totalSubscriptions > 0" class="flex align-items-center justify-content-between">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalSubscriptions ? totalSubscriptions : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalSubscriptions}}
              {{(totalSubscriptions > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
    <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
    <div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="username">{{'attribute.username' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <input appAutoFocus [focus]="filtersVisible" class="w-full" id="username" type="text" pInputText
                 [(ngModel)]="currentFilters.username" (keyup.enter)="filtersVisible = false; applyFilters()">
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="serialNumber">{{'attribute.serialNumber' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <input [(ngModel)]="currentFilters.serialNumber" (keyup.enter)="filtersVisible = false; applyFilters()"
                 pInputText class="w-full" id="serialNumber" type="text">
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="startDate">{{'attribute.startDate' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-calendar id="startDate" [ngModel]="startDate" [firstDayOfWeek]="1"
                      (ngModelChange)="this.startDate = $event; this.setDate('startDate', $event)" [showTime]="true"
                      dateFormat="dd/mm/yy" [placeholder]="'select.dateTime' | transloco" readonlyInput="true" [hideOnDateTimeSelect]="false"
                      appendTo="body" styleClass="w-full" [monthNavigator]="true" [yearNavigator]="true" [showIcon]="true"
                      [yearRange]="availableYearRange">
          </p-calendar>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="endDate">{{'attribute.endDate' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <p-calendar id="endDate" [ngModel]="endDate" [firstDayOfWeek]="1"
                      (ngModelChange)="this.endDate = $event; this.setDate('endDate', $event)" [showTime]="true"
                      dateFormat="dd/mm/yy" [placeholder]="'select.dateTime' | transloco" readonlyInput="true" [hideOnDateTimeSelect]="false"
                      appendTo="body" styleClass="w-full" [monthNavigator]="true" [yearNavigator]="true" [showIcon]="true"
                      [yearRange]="availableYearRange">
          </p-calendar>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label>{{'misc.status' | transloco}}</label>
        </div>
        <div class="col-12">
          <div class="mb-1">
            <p-radioButton name="active" label="{{'misc.activeInactive' | transloco}}" [value]="null"
                           [(ngModel)]="currentFilters.active">
            </p-radioButton>
          </div>
          <div class="mb-1">
            <p-radioButton name="active" label="{{'misc.activeOnly(f)' | transloco}}" [value]="true"
                           [(ngModel)]="currentFilters.active">
            </p-radioButton>
          </div>
          <div class="p-field-radiobutton margin-top">
            <p-radioButton name="active" label="{{'misc.inactiveOnly(f)' | transloco}}" [value]="false"
                           [(ngModel)]="currentFilters.active"></p-radioButton>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="organization">{{'model.organization' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <p-treeSelect [(ngModel)]="organizations" [placeholder]="'select.generic' | transloco"
                        [propagateSelectionUp]="false" [propagateSelectionDown]="false" display="chip" appendTo="body"
                        [options]="hierarchy" [metaKeySelection]="false" selectionMode="checkbox" id="organization">
          </p-treeSelect>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="organizationCode">{{'model.organizationCode' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <p-multiSelect [(ngModel)]="organizations" [placeholder]="'select.generic' | transloco"
                         [filter]="true" display="chip" styleClass="w-full" appendTo="body" [options]="organizationCodes"
                         id="organizationCode"></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <p-button type="button" (onClick)="filtersVisible = false; applyFilters()"
                  label="{{'common.filter' | transloco}}" styleClass="p-button-primary mx-2 mt-2" [disabled]="!(
                  currentFilters.username ||
                  currentFilters.serialNumber ||
                  currentFilters.startDate ||
                  currentFilters.endDate ||
                  currentFilters.active != null ||
                  organizations)">
        </p-button>
        <p-button type="button" (click)="resetFilters(); filtersVisible = false; applyFilters()"
                  label="{{'common.clear' | transloco}}" styleClass="p-button-danger"></p-button>
      </div>
    </div>
  </p-sidebar>
</div>
